<div class="bloco" [formGroup]="form">
  <div class="row g-3">
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>CST IPI</mat-label>
        <mat-select formControlName="codigoCst" (selectionChange)="onCstSelecionado()">
          <mat-option [value]="null">Selecione</mat-option>
          @for (c of listaCstIpiSaida; track c.codigo) {
            <mat-option [value]="c.codigo">{{ c.codigo }} - {{ c.descricao }}</mat-option>
          }
        </mat-select>
        @if (listaCstIpi.length === 0) {
          <mat-hint>Lista indisponível - verifique o aviso acima</mat-hint>
        }
      </mat-form-field>
    </div>

    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>Código de enquadramento</mat-label>
        <input matInput type="text" formControlName="codigoEnquadramento" maxlength="3">
      </mat-form-field>
    </div>

    @if (cstIpiTexto) {
      <div class="col-12">
        <app-alert-card [type]="cstIpiTexto.alertaTipo" [title]="cstIpiTexto.alertaTitulo">
          {{ cstIpiTexto.alertaTexto }}
        </app-alert-card>
      </div>
    } @else {
      <div class="col-12">
        <app-empty-state icon="percent" title="Selecione o CST"
          subtitle="Os campos e os valores apurados aparecem conforme o código informado."></app-empty-state>
      </div>
    }

    @if (algumAtivo(['pIPI', 'vUnid'])) {
      @if (ativo('pIPI')) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>percent</mat-icon>
            <span>Ad valorem</span>
          </div>
          <div class="row g-3">
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Base de cálculo</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="valorMask" formControlName="valorBaseCalculo" class="campo-numero">
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota IPI (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquota" class="campo-numero">
                @if (form.get('percentualAliquota')?.hasError('required') && form.get('percentualAliquota')?.touched) {
                  <mat-error>Informe a alíquota ou o valor por unidade.</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      }

      @if (ativo('vUnid')) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>straighten</mat-icon>
            <span>Ad rem</span>
          </div>
          <div class="row g-3">
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Quantidade (unidade tributável)</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="decimalMask" formControlName="quantidadeUnidade" class="campo-numero">
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Valor por unidade (R$)</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="currencyMask" formControlName="valorUnidade" class="campo-numero">
                @if (form.get('valorUnidade')?.hasError('required') && form.get('valorUnidade')?.touched) {
                  <mat-error>Informe a alíquota ou o valor por unidade.</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      }

      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>calculate</mat-icon>
            <span>Valores apurados</span>
          </div>
          @if (isRecalculoPendente || form.get('valorIpi')?.value == null) {
            <app-empty-state icon="calculate" title="Nenhum valor apurado"></app-empty-state>
          } @else {
            <div class="row g-3">
              <div class="col-6 col-md-3">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>Base</mat-label>
                  <input matInput type="text" [value]="form.get('valorBaseCalculo')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                </mat-form-field>
              </div>
              <div class="col-6 col-md-3">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>Alíquota (%)</mat-label>
                  <input matInput type="text" [value]="form.get('percentualAliquota')?.value || 0 | abnt: 'quantidade': 2" [disabled]="true" class="campo-numero">
                </mat-form-field>
              </div>
              <div class="col-6 col-md-3">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>Valor do IPI</mat-label>
                  <input matInput type="text" [value]="form.get('valorIpi')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                </mat-form-field>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
